export enum EUserRoles {
  role_administator = 'role_administator',
  role_driver = 'role_driver',
  role_channel_administrator = 'role_channel_administrator',
  role_service_provider_owner = 'role_service_provider_owner',
  role_user_client = 'role_user_client',
  role_locker_owner = 'role_locker_owner',
  role_service_provider_operator = 'role_service_provider_operator',
}
